//@ts-nocheck

import isHotkey from 'is-hotkey'
import { Registry } from '@react-registry'
import { Editor, Range, Transforms, Node, Path } from 'slate'

import { indentMultipleListItems, outdentMultipleListItems } from '../elements/Element/list/ListItem/utils'
import { insertRowAtEnd } from '../elements/Element/table/utils/insertRowAtEnd'
import { indentNode, outdentNode } from '../elements/Element/indentation/utils'

const indentOrInsertTab = (editor) => {
  const { selection } = editor
  if (!selection) {
    editor.insertText('\t')
    return
  }

  if (Range.isExpanded(selection)) {
    indentNode(editor)
    return
  }

  const [node, path] = Editor.node(editor, selection)
  const isAtStart = (node && typeof node === 'object' && 'text' in node)
    ? selection.anchor.offset === 0
    : Editor.isStart(editor, selection.anchor, path)

  if (isAtStart) {
    indentNode(editor)
  } else {
    editor.insertText('\t')
  }
}

export const handleSoftBreak = ({ editor, event }) => {
  if (isHotkey('tab', event)) {
    if (event.defaultPrevented) {
      return
    }
    event.preventDefault()
    const { selection } = editor
    if (selection) {
      const [li] = Editor.nodes(editor, {
        match: (n) => n.type === 'li',
        mode: 'lowest'
      })
      const [cell] = Editor.nodes(editor, {
        match: (n) => n.type === 'td' || n.type === 'th',
        mode: 'lowest',
      })

      const [hyperlink] = Editor.nodes(editor, {
        match: (n) => n.type === 'a'
      })

      if (li && ((Range.isCollapsed(selection) && selection.anchor.offset === 0) || Range.isExpanded(selection))) {
        indentMultipleListItems(editor)
      }
      else if (cell) {
        const [table] = Editor.nodes(editor, {
          match: (n) => n.type === 'table',
          mode: 'lowest',
        })
        const [row] = Editor.nodes(editor, {
          match: (n) => n.type === 'tr',
          mode: 'lowest',
        })
        const [rowParent] = Editor.nodes(editor, {
          match: (n) => n.type === 'tbody' || n.type === 'thead',
          mode: 'lowest'
        })
        const nextCell = Editor.next(editor, {
          match: (n) => ['td', 'th'].includes(n.type) && !editor.isVoid(n),
          mode: 'lowest',
          at: cell[1],
        })
        if (table && rowParent && row) {
          if (nextCell) {
            Transforms.select(editor, nextCell[1])
            return
          }
          insertRowAtEnd(editor, table[1])
          handleSoftBreak({ editor, event })
          return
        }
      }
      else if (hyperlink) {
        let path = hyperlink[1]
        const hasPathPreviousHyperlink = Path.hasPrevious(path)
        if (hasPathPreviousHyperlink) {
          const previousNode = Editor.node(editor, Path.previous(path))
          const isLineBreakNode = previousNode?.[0]?.text === '\n'
          if (isLineBreakNode) {
            Transforms.insertNodes(editor, { text: '\t' }, { at: Path.next(previousNode[1]) })
          }
          else {
            indentOrInsertTab(editor)
          }
        }
      }
      else {
        indentOrInsertTab(editor)
      }
    }
  }

  if (isHotkey('shift+enter', event)) {
    event.preventDefault()
    
    const [codeBlock] = Editor.nodes(editor, {
      match: n => n.type === 'code',
      mode: 'lowest'
    })
    if (!codeBlock) {
      if (editor.csBreakLineOnEnter) {
        Transforms.insertNodes(editor, { type: 'p', children: [{ text: '' }] }, { at: editor.selection, select: true })
        return;
      }
      editor.insertText('\n')
    }
  }

  if (isHotkey('shift+tab', event)) {
    event.preventDefault()

    const { selection } = editor

    if (selection) {
      const [li] = Editor.nodes(editor, {
        match: (n) => n.type === 'li',
        mode: 'lowest'
      })

      if (li) {
        outdentMultipleListItems(editor)
        return
      }
      else {
        if (Range.isExpanded(selection)) {
          outdentNode(editor)
          return
        }

        // For collapsed selection, outdent only if cursor is at start
        const [node, path] = Editor.node(editor, selection)
        const isAtStart = (node && typeof node === 'object' && 'text' in node)
          ? selection.anchor.offset === 0
          : Editor.isStart(editor, selection.anchor, path)

        if (isAtStart) {
          outdentNode(editor)
        }
      }

    }
  }
}

Registry.register(handleSoftBreak, {
  id: 'softbreak',
  registry: 'keydown'
})
